// File: src/components/social/UserCard/UserCard.tsx
// Purpose: Social interaction component (comments, likes, shares)

import React from "react";
import styled from "styled-components";
import { Typography } from "../../general/Typography";;
import { Avatar } from "../Avatar/Avatar";
import { FollowButton } from "../FollowButton/FollowButton";

interface UserCardProps {
  name: string;
  bio?: string;
  avatarSrc?: string;
  isFollowing?: boolean;
  onFollowToggle?: () => void;
}

const CardWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.radii.md};
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.elevations.low};
  gap: ${({ theme }) => theme.spacing.md};
`;

const UserInfo = styled.div`
  flex-grow: 1;
`;

export const UserCard: React.FC<UserCardProps> = ({
  name,
  bio,
  avatarSrc,
  isFollowing,
  onFollowToggle,
}) => {
  return (
    <CardWrapper>
      <Avatar src={avatarSrc} name={name} size="md" />
      <UserInfo>
        <Typography variant="heading3">{name}</Typography>
        {bio && <Typography variant="bodySmall" color="textSecondary">{bio}</Typography>}
      </UserInfo>
      <FollowButton isFollowing={isFollowing} onToggle={onFollowToggle} />
    </CardWrapper>
  );
};